import { create } from 'zustand';
import type { CategoryFilter } from '@/lib/types';

interface UiState {
  profileModalOpen: boolean;
  questModalOpen: boolean;
  activeQuestId: string | null;
  categoryModalOpen: boolean;
  activeCategoryKey: string | null;
  categoryFilter: CategoryFilter;
  setCategoryFilter: (f: CategoryFilter) => void;
  openQuest: (id: string) => void;
  closeQuest: () => void;
  openProfile: () => void;
  closeProfile: () => void;
  openCategoryDetail: (key: string) => void;
  closeCategoryDetail: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  profileModalOpen: false,
  questModalOpen: false,
  activeQuestId: null,
  categoryModalOpen: false,
  activeCategoryKey: null,
  categoryFilter: 'all',
  setCategoryFilter: (f) => set({ categoryFilter: f }),
  openQuest: (id) => set({ questModalOpen: true, activeQuestId: id }),
  closeQuest: () => set({ questModalOpen: false, activeQuestId: null }),
  openProfile: () => set({ profileModalOpen: true }),
  closeProfile: () => set({ profileModalOpen: false }),
  openCategoryDetail: (key) => set({ categoryModalOpen: true, activeCategoryKey: key }),
  closeCategoryDetail: () => set({ categoryModalOpen: false, activeCategoryKey: null }),
}));
